"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Select = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const React = tslib_1.__importStar(require("react"));
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const uuid_1 = require("uuid");
require("./select.css");
const DoubleArrow_1 = require("@nbc-design/icons/lib/web/DoubleArrow");
/** Select lets users choose one option from an options menu. */
exports.Select = React.forwardRef(({ name, placeholder, clearable, optGroup, options, className, selectClassName, dataTest, value, defaultValue, onChange, length, ...others }, ref) => {
    const [selectValue, setSelectValue] = React.useState(value || value === 0 ? value : defaultValue);
    React.useEffect(() => {
        (value || value === '' || value === 0) && setSelectValue(value);
    }, [value]);
    const placeholderOption = placeholder && ((0, jsx_runtime_1.jsx)("option", { value: "", disabled: !clearable, children: placeholder }));
    const optionMarkup = (option) => {
        return ((0, jsx_runtime_1.jsx)("option", { value: option.value, disabled: option.disabled, children: option.label }, (0, uuid_1.v4)()));
    };
    const optGroupMarkup = (group) => {
        return group.label ? ((0, jsx_runtime_1.jsx)("optgroup", { label: group.label, disabled: group.disabled, children: group.options.map((option) => optionMarkup(option)) }, (0, uuid_1.v4)())) : (group.options.map((option) => optionMarkup(option)));
    };
    const selectOptions = optGroup
        ? optGroup.map((group) => optGroupMarkup(group))
        : options?.map((option) => optionMarkup(option));
    const handleOnChange = (event) => {
        setSelectValue(event.currentTarget.value);
        onChange?.(event);
    };
    const classes = (0, classnames_1.default)('dsc-select', !selectValue && selectValue !== 0 && placeholder && 'is-placeholder', selectClassName);
    const containerClasses = (0, classnames_1.default)('dsc-select__container', length && `is-${length}`, className);
    return ((0, jsx_runtime_1.jsxs)("div", { className: containerClasses, children: [(0, jsx_runtime_1.jsxs)("select", { ...others, name: name, className: classes, "data-test": dataTest || name, ref: ref, value: selectValue, onChange: handleOnChange, children: [placeholderOption, selectOptions] }), (0, jsx_runtime_1.jsx)(DoubleArrow_1.DoubleArrow, { size: "small", className: "dsc-select__icon" })] }));
});
exports.Select.displayName = 'Select';
//# sourceMappingURL=select.js.map